import React from 'react';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCaretDown, faCaretUp} from '@fortawesome/free-solid-svg-icons';

import {PrimaryButton} from 'Components/Button';
import {
    FormHandler,
    Input,
    Label,
    FileUpload,
    Textarea,
    BooleanSelect,
    Dietaries,
    EmergencyContactDetails,
    Radio
} from 'Components/Form';
import {Alert, Loading} from 'Components/Partials';
import {DisplayTimeZone, DisplayLanguage} from 'Components/Settings';
import {MailLink} from 'Components/Utilities';

import {getFallbackAvatarUrl} from 'Services/AuthHelpers';
import Me from 'Services/Api/Me/Me';

import SettingsLayout from 'Components/Layouts/SettingsLayout';
import AdminLayout from 'Pages/Admin/AdminLayout';
import { User } from "Services";

class SiteProfile extends React.Component {
    /**
     * @var success
     * @type {string}
     */
    success = 'Your details have been updated successfully';

    /**
     * @var displayAvatar
     * @type {boolean}
     */
    displayAvatar = true;

    /**
     * @var state
     */
    state = {
        loading: true,
        user_id: this.props.match?.params?.user ?? null,
        success: false,
        invitesShown: []
    };

    /**
     * @method componentDidMount
     */
    componentDidMount = () => {
        this.loadUser();
    };

    /**
     * @method loadUser
     */
    loadUser = async () => {
        const {user_id} = this.state;

        // Request the data.
        const response = await Me.getMe({
            includeHasInvited: true,
            user_id
        });

        // Increment the invites array keys as we are 1 based for this form.
        let invites = [];

        if (response.data.data.has_invited) {
            for (var i=0; i < response.data.data.has_invited.length; i++) {
                invites[i+1] = response.data.data.has_invited[i];
            }
        }

        // Set the form values.
        this.props.setForm({
            ...response.data.data,
            invites,
            user_id
        });

        // Finish loading.
        this.setState({
            loading: false
        });
    }

    /**
     * @method getFormValues
     * @param {integer|null} index
     * @return {object}
     */
    getFormValues = (index) => {
        const {form} = this.props;

        return index !== null ?
            (form['invites'] && form['invites'][index] ?
                form['invites'][index] :
                null) :
            form;
    }

    /**
     * @method getFormkey
     * @param {integer|null} index
     * @return {string}
     */
    getFormkey = (index) => {
        return index !== null ?
            'invites.' + index + '.' :
            '';
    }

    /**
     * @method handleToggleInvite
     * @param {integer} index
     */
    handleToggleInvite = (index) => {
        const {invitesShown} = this.state;

        this.setState({
            invitesShown: {
                ...invitesShown,
                [index]: !invitesShown[index]
            }
        });
    }

    /**
     * @method handleSuccess
     */
    handleSuccess = () => {
        this.setState({
            success: true
        });
    }

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const {user_id} = this.state;

        if (user_id) {
            return (
                <AdminLayout title={'Users - Profile'}>
                    {this.renderPage()}
                </AdminLayout>
            );
        }

        return (
            <SettingsLayout title="Profile">
                {this.renderPage()}
            </SettingsLayout>
        );
    }

    /**
     * @method renderPage2
     * @return {JSX.Element}
     */
    renderPage() {
        const {loading} = this.state;
        const {form, working, alert, handleInput, handleSubmit} = this.props;

        if (loading) {
            return <Loading />;
        }

        return (
            <form
                autoComplete="off"
                onSubmit={(e) => handleSubmit(e, Me.updateProfile,  "Profile successfully updated")}
            >
                <div className="p-6 text-center  max-w-6xl mx-auto">
                    <h1 className="text-black text-5xl mb-4 font-bold boots-sharp">
                        Profile
                    </h1>

                    {this.renderProfileCopy()}
                </div>

                <div className="p-6">
                    {alert !== null && (<Alert {...alert} />)}

                    {this.displayAvatar &&
                        <FileUpload
                            containerClassName="m-8 mt-4 flex flex-col justify-center items-center gap-4"
                            value={form.avatar_path}
                            onChange={v => handleInput('avatar_path', v)}
                            accept="image/*"
                            placeholder="Update Picture"
                            fallbackImage={getFallbackAvatarUrl(form)}

                        />
                    }

                    {this.renderForm(null, form.first_group_name)}

                    {/*{form.number_of_invites > 0 && this.renderInvites()}*/}
                </div>

                <div className="p-6 flex justify-between">
                    <PrimaryButton
                        text="Save"
                        working={working}
                    />
                </div>
            </form>
        );
    }

    /**
     * @method renderProfileCopy
     * @return {JSX.Element}
     */
    renderProfileCopy() {
        const {form} = this.props;
        return (
            <>
                {form.first_group_name === 'Store Manager' &&
                    <>
                        <p className="text-black font-light w-full mx-auto mt-2 ">
                            Please complete your profile details.
                        </p>
                    </>
                }
            </>
        );
    }

    /**
     * @method renderPage
     * @return {JSX.Element}
     */
    renderInvites() {
        const {invitesShown} = this.state;
        const {form} = this.props;
        return (
            <>
                {[...Array(form.number_of_invites)].map((e, i) => (
                    <div key={i}>
                        <div
                            className={`
                                text-white text-3xl bg-gray-500 w-full cursor-pointer px-4 py-2 mt-8 mb-4
                                select-none flex flex-row justify-between items-center
                            `}
                            onClick={() => this.handleToggleInvite(i)}
                        >
                            <p>
                                {form.number_of_invites > 1 && i === 0 ? 'Store Manager' : 'Advisor ' + i}
                            </p>

                            <FontAwesomeIcon
                                icon={invitesShown[i] ? faCaretUp : faCaretDown}
                            />
                        </div>

                        {invitesShown[i] && this.renderForm((i+1), 'Advisor')}
                    </div>
                ))}
            </>
        );
    }

    /**
     * @method renderPage
     * @param {integer|null} index
     * @param {string} group_name
     * @return {JSX.Element}
     */
    renderForm(index, group_name) {
        const {form} = this.props;

        let values = this.getFormValues(index);
        let key = this.getFormkey(index);

        return this.renderProfileForm(key, values);
    }
    /**
     * @method renderProfileForm
     * @return {JSX.Element}
     */
    renderProfileForm(key, values) {
        const {form, handleInput, getFieldError} = this.props;
        return (
            <div className="flex flex-col gap-4 mb-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-4">
                    <Input
                        label="First Name"
                        value={values?.first_name}
                        id="first_name"
                        error={getFieldError(key + 'first_name')}
                        onChange={(v) => handleInput(key + 'first_name', v)}
                        containerClassName={"flex flex-row font-bold"}
                    />

                    <Input
                        label="Last Name"
                        value={values?.last_name}
                        id="last_name"
                        error={getFieldError(key + 'last_name')}
                        onChange={(v) => handleInput(key + 'last_name', v)}
                        containerClassName={"flex flex-row"}
                    />

                    <Input
                        label="Position"
                        value={values?.position ?? 'Store Manager'}
                        id="position"
                        error={getFieldError(key + 'position')}
                        onChange={(v) => handleInput(key + 'position', v)}
                        containerClassName={"flex flex-row"}
                    />
                </div>
            </div>
        );
    }
    /**
     * @method renderAdvisorForm
     * @param {object|null} values
     * @param {string} key
     * @return {JSX.Element}
     */
    renderAdvisorForm(values, key) {
        const {form, handleInput, getFieldError} = this.props;
        return (
            <div className="flex flex-col gap-4 mb-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 bg-gray-200 p-4">
                    {key !== 'invites.1.' && (
                        <>
                            <Input
                                label="Employee Number"
                                value={values?.employee_number}
                                id="employee_number"
                                error={getFieldError(key + 'employee_number')}
                                onChange={(v) => handleInput(key + 'employee_number', v)}
                                containerClassName={"flex flex-row"}
                            />

                            <Input
                                label="First Name"
                                value={values?.first_name}
                                id="first_name"
                                error={getFieldError(key + 'first_name')}
                                onChange={(v) => handleInput(key + 'first_name', v)}
                                containerClassName={"flex flex-row"}
                            />

                            <Input
                                label="Last Name"
                                value={values?.last_name}
                                id="last_name"
                                error={getFieldError(key + 'last_name')}
                                onChange={(v) => handleInput(key + 'last_name', v)}
                                containerClassName={"flex flex-row"}
                            />

                            <Input
                                label="Position"
                                value={values?.position}
                                id="position"
                                error={getFieldError(key + 'position')}
                                onChange={(v) => handleInput(key + 'position', v)}
                                containerClassName={"flex flex-row"}
                            />

                            <Input
                                label={'Email'}
                                value={values?.email}
                                id="email"
                                error={getFieldError(key + 'email')}
                                onChange={(v) => handleInput(key + 'email', v)}
                                readOnly={!window.base.features.allow_email_change && !key}
                                containerClassName={"flex flex-row"}
                            />

                            <Textarea
                                label="Do you need any assistance with viewing?"
                                value={values?.special_access_requirements}
                                id="special_access_requirements"
                                error={getFieldError(key + 'special_access_requirements')}
                                onChange={(v) => handleInput(key + 'special_access_requirements', v)}
                            />
                        </>
                    )}
                    {key === 'invites.1.' && (
                        <>
                            <Input
                                label="First Name"
                                value={values?.first_name}
                                id="first_name"
                                error={getFieldError(key + 'first_name')}
                                onChange={(v) => handleInput(key + 'first_name', v)}
                                containerClassName={"flex flex-row"}
                            />

                            <Input
                                label="Last Name"
                                value={values?.last_name}
                                id="last_name"
                                error={getFieldError(key + 'last_name')}
                                onChange={(v) => handleInput(key + 'last_name', v)}
                                containerClassName={"flex flex-row"}
                            />

                            <Input
                                label="Position"
                                value={values?.position ?? 'Store Manager'}
                                id="position"
                                error={getFieldError(key + 'position')}
                                onChange={(v) => handleInput(key + 'position', v)}
                                containerClassName={"flex flex-row"}
                            />

                            <Input
                                label={`Email`}
                                value={values?.email ?? User.data.email}
                                id="email"
                                error={getFieldError(key + 'email')}
                                onChange={(v) => handleInput(key + 'email', v)}
                                readOnly={!window.base.features.allow_email_change && !key}
                                containerClassName={"flex flex-row"}
                            />

                            <Textarea
                                label="Do you need any assistance with viewing?"
                                value={values?.special_access_requirements}
                                id="special_access_requirements"
                                error={getFieldError(key + 'special_access_requirements')}
                                onChange={(v) => handleInput(key + 'special_access_requirements', v)}
                                containerClassName={"flex flex-row"}
                            />
                        </>
                    )}
                </div>

                {/*<div className="grid grid-cols-1 md:grid-cols-2 gap-4 bg-gray-200 p-4">
                    <Dietaries
                        value={values?.dietaries}
                        error={getFieldError(key + 'dietaries')}
                        onChange={(v) => handleInput(key + 'dietaries', v)}
                        containerClassName={"flex flex-row"}
                    />
                </div>*/}

                {/*<div className="bg-gray-200 p-4">
                    <BooleanSelect
                        label={`
                            Accommodation is available on the night prior to the event,
                            for those that are having to travel over 3 hours. Do your advisors require accommodation?
                        `}
                        value={values?.accomodation}
                        id="accomodation"
                        error={getFieldError(key + 'accomodation')}
                        onChange={(v) => handleInput(key + 'accomodation', v)}
                    />
                </div>*/}

                {/*<div>
                    <EmergencyContactDetails
                        value={values?.emergency_contact_details}
                        error={getFieldError(key + 'emergency_contact_details')}
                        onChange={(v) => handleInput(key + 'emergency_contact_details', v)}
                    />
                </div>*/}
            </div>
        );
    }

    /**
     * @method renderStoreManagerForm
     * @param {object|null} values
     * @param {string} key
     * @return {JSX.Element}
     */
    renderStoreManagerForm(values, key) {
        const {handleInput, getFieldError} = this.props;

        return (
            <>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4 font-light">
                    <Input
                        label="Store Number"
                        value={values?.store_number}
                        id="store_number"
                        error={getFieldError(key + 'store_number')}
                        onChange={(v) => handleInput(key + 'store_number', v)}
                        containerClassName={"flex flex-row"}
                    />

                    <Input
                        label="Store Name"
                        value={values?.store_name}
                        id="store_name"
                        error={getFieldError(key + 'store_name')}
                        onChange={(v) => handleInput(key + 'store_name', v)}
                        containerClassName={"flex flex-row"}
                    />

                    <Input
                        label="Store Address"
                        value={values?.store_address}
                        id="store_address"
                        error={getFieldError(key + 'store_address')}
                        onChange={(v) => handleInput(key + 'store_address', v)}
                        containerClassName={"flex flex-row"}
                    />

                    <Input
                        label="Region"
                        value={values?.region}
                        id="region"
                        error={getFieldError(key + 'region')}
                        onChange={(v) => handleInput(key + 'region', v)}
                        containerClassName={"flex flex-row"}
                    />

                    {/*<Input
                        label="Email address"
                        value={values?.email}
                        id="email"
                        error={getFieldError(key + 'email')}
                        onChange={(v) => handleInput(key + 'email', v)}
                        readOnly={!window.base.features.allow_email_change && !key}
                        containerClassName={"flex flex-row"}
                    />*/}
                    <div className="flex flex-row">
                        <Label className="mb-0 font-light w-1/3" label="Will you be attending?" />

                        <div className="flex flex-row space-x-2 font-light">
                            <Radio
                                id="attending-yes"
                                label="Yes"
                                labelPlacement="right"
                                value={values?.is_attending === true}
                                onChange={e => handleInput('is_attending', true)}
                            />
                            <Radio
                                id="attending-no"
                                label="No"
                                labelPlacement="right"
                                value={values?.is_attending === false}
                                onChange={e => handleInput('is_attending', false)}
                            />
                        </div>
                    </div>
                </div>
            </>
        );
    }

    /**
     * @method renderStoreManagerForm
     * @param {object|null} values
     * @param {string} key
     * @return {JSX.Element}
     */
    renderSupportOfficeForm(values, key) {
        const {handleInput, getFieldError} = this.props;

        return (
            <>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4 font-light">
                    <Input
                        label="First Name"
                        value={values?.first_name}
                        id="first_name"
                        error={getFieldError(key + 'first_name')}
                        onChange={(v) => handleInput(key + 'first_name', v)}
                        containerClassName={"flex flex-row"}
                    />

                    <Input
                        label="Last Name"
                        value={values?.last_name}
                        id="last_name"
                        error={getFieldError(key + 'last_name')}
                        onChange={(v) => handleInput(key + 'last_name', v)}
                        containerClassName={"flex flex-row"}
                    />

                    <Input
                        label="Role"
                        value={values?.position}
                        id="position"
                        error={getFieldError(key + 'position')}
                        onChange={(v) => handleInput(key + 'position', v)}
                        containerClassName={"flex flex-row"}
                    />

                    <Input
                        label="Email address"
                        value={values?.email}
                        id="email"
                        error={getFieldError(key + 'email')}
                        onChange={(v) => handleInput(key + 'email', v)}
                        readOnly={!window.base.features.allow_email_change && !key}
                        containerClassName={"flex flex-row"}
                    />
                </div>
            </>
        );
    }
}

export default FormHandler(SiteProfile);
